// Contains RSSI and Zone radius mappings

import { UnitConverter } from './unit_converter'

export const rssiForRadius = (r, unit) => {
  const x = Number(r)
  if (!Number.isFinite(x)) return -45
  if (x <= 0) return -45

  if (x < UnitConverter.convert(1, 'm', unit)) return -45
  if (x === UnitConverter.convert(1, 'm', unit)) return -50
  if (x <= UnitConverter.convert(1.5, 'm', unit)) return -53
  if (x <= UnitConverter.convert(2, 'm', unit)) return -55
  if (x <= UnitConverter.convert(2.5, 'm', unit)) return -60
  if (x <= UnitConverter.convert(3, 'm', unit)) return -62
  if (x <= UnitConverter.convert(4, 'm', unit)) return -63
  if (x <= UnitConverter.convert(5, 'm', unit)) return -64
  if (x <= UnitConverter.convert(6, 'm', unit)) return -65
  if (x <= UnitConverter.convert(7, 'm', unit)) return -70
  if (x <= UnitConverter.convert(9, 'm', unit)) return -75
  if (x <= UnitConverter.convert(11, 'm', unit)) return -80
  if (x <= UnitConverter.convert(12, 'm', unit)) return -85
  if (x <= UnitConverter.convert(13, 'm', unit)) return -90
  if (x <= UnitConverter.convert(15, 'm', unit)) return -95
  return -100
}
